import { signal, effect } from "@preact/signals-react";

export interface MessageData {
  message: string;
  type: "info" | "success" | "error";
  id: string;
}

export const notificationsAfterLogin = signal<MessageData[]>([]);
export const notificationsBeforeLogin = signal<MessageData[]>([]);

// Clear notificationsAfterLogin after 4 seconds
effect(() => {
  if (notificationsAfterLogin.value.length === 0) {
    return;
  }

  setTimeout(() => {
    notificationsAfterLogin.value = [];
  }, 4000);
});

// Clear notificationsBeforeLogin after 4 seconds
effect(() => {
  if (notificationsBeforeLogin.value.length === 0) {
    return;
  }

  setTimeout(() => {
    notificationsBeforeLogin.value = [];
  }, 4000);
});
